export class SearchCondition {
  class_code: string = ""
  name: string = ""
  level: string = ""
}

export class Classifcation {
  id: number
  class_code: number
  name: string
  level: string

  constructor(className: any){
    this.id = className.id;
    this.class_code = className.class_code;
    this.name = className.name;
    this.level = className.level;
  }
}